import { v4 as uuid } from "uuid";
import CustomerAPI from "@/api/CustomerAPI";
import { createSlice, current, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import {COMPANY_CHECK} from "@/actions/globalConst";
import { useParams, useNavigate, useLocation, Navigate } from "react-router-dom";


let initialState = {
    pagination: false,
    items: [],
    view: COMPANY_CHECK.VIEW_OVERVIEW,
    apiState: COMPANY_CHECK.API_INIT,
    key: "",
    error: null
};


const rejectEventHandler=((state, action) => {
    state.error = action.payload;
    state.key = uuid().slice(0, 8);
});
const pendingEventHandler=((state, action) => {
    state.apiState = COMPANY_CHECK.API_PROCESSING;
})
let fullFilledEventHandler= ( (state, action) => {
    if(action.payload.data.items) {
        state.items = action.payload.data.items;
    }
    if(action.payload.data.pagination) {
        state.pagination = action.payload.data.pagination;
        //localStorage.setItem("refreshView", 'calender');
    }

    state.view = COMPANY_CHECK.CREATE_TASK;

/*    
    if(action.type == "com_api_save/fulfilled" || action.type == "com_api_delete/fulfilled" || action.type == "GET_TASKS/fulfilled") {
        state.apiState = COMCYCLE.API_REFRESH;
    } else {
      state.apiState = COMCYCLE.API_READY;  
    }
*/
    //;
      state.apiState = COMPANY_CHECK.API_READY;  
    state.key = uuid().slice(0, 8);
    state.error = null;
    return state;
})

let task = null;
const CustomerCheckReducer = createSlice({
  name: 'CustomerCheck',
  initialState,
  reducers: {
        
    // omit existing reducers here
  },
  extraReducers(builder) {
      
    task = companyKvKCheck;
    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandler(state, action)).addCase(task.rejected, (state, action) => rejectEventHandler(state, action)).addCase(task.pending, (state, action) => pendingEventHandler(state, action));

  }
})


export const companyKvKCheck = createAsyncThunk(COMPANY_CHECK.API_KVK_CHECK, async (data:any, event) => {
    let response = null;
    try {
          response = await CustomerAPI.checkKvK(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

//export const { setChangedItems, storeCalenderSettings, setUpdate, setDragItem, checkItem,setSelectedDate, getState, setSelectedUsers} = CommunicationCycleReducer.actions;
export default CustomerCheckReducer.reducer